module.exports = "/images/undo.svg?f29ea3371914f2fc4b3575adee0ce717";